// 期限切れ
export const EXPIRED = 2;
//  取り下げ
export const CANCELED = 3;
// 決済エラー
export const FAILED_CHARGING = 5;
